<template>
  <v-dialog
    v-model="value"
    persistent
    max-width="450px"
    scrollable
    class="scrollDesign"
  >
    <v-card>
      <v-card-title class="headline gradiente lighten-2 elevation-3">
        <span class="white--text">
          {{ isMassiveStudentOptions[isMassiveQrStudents].title }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12>
            <v-card-text
              style="justify-content: center; text-align: -webkit-center"
              v-show="this.std"
            >
              <h2>
                {{ isMassiveStudentOptions[isMassiveQrStudents].description }}
              </h2>
            </v-card-text>
            <v-card-text
              style="justify-content: center; text-align: -webkit-center"
              v-show="this.coll"
            >
              <h2>
                Al activar el código de este colaborador, volverá a ser válido
                para el ingreso al colegio, ¿Deseas activarlo?
              </h2>
            </v-card-text>
            <v-card-text
              style="justify-content: center; text-align: -webkit-center"
              v-show="this.par"
            >
              <h2>
                Al activar el código de este tutor, volverá a ser válido para el
                ingreso al colegio, ¿Deseas activarlo?
              </h2>
            </v-card-text>

            <v-card-actions style="justify-content: center">
              <v-btn
                color="primary"
                small
                @click="close"
                style="padding: 17px; margin: 17px"
                >CANCELAR</v-btn
              >
              <v-btn
                color="black"
                small
                @click="imput"
                style="
                  padding: 17px;
                  margin: 17px;
                  color: white;
                  background: black;
                "
                >ACTIVAR</v-btn
              >
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <loading v-model="toast.loading" text="Trabajando..."></loading>
    <success
      v-model="toast.success"
      :text="isMassiveStudentOptions[isMassiveQrStudents].succes"
    ></success>
    <error v-model="toast.failed" :text="toast.fmessage"></error>
    <alert
      v-model="toast.unauthorized"
      title="Aviso"
      :description="toast.description"
    ></alert>
  </v-dialog>
</template>

<script>
import alert from '../Dialogs/Alert.vue'
import error from '../Dialogs/Error.vue'
import loading from '../Dialogs/Loading.vue'
import success from '../Dialogs/Success.vue'

export default {
  props: ['std', 'coll', 'par', 'value', 'student'],
  components: {
    loading,
    success,
    error,
    alert,
  },
  data: () => ({
    isMassiveStudentOptions: {
      true: {
        title: 'Activar QRs',
        description:
          'Al activar los códigos de estos alumnos, volverán a ser válidos para el ingreso al colegio, ¿Deseas activarlos?',
        succes: 'QR Bloqueados correctamente',
      },
      false: {
        title: 'Activar QR',
        description:
          'Al activar el código de este alumno, volverá a ser válido para el ingreso al colegio, ¿Deseas activarlo?',
        succes: 'QR Bloqueado correctamente',
      },
    },
    isMassiveQrStudents: false,
    obj: {
      disable: false,
      reason: '',
      id: '',
    },
    toast: {
      loading: false,
      success: false,
      failed: false,
      unauthorized: false,
      fmessage: 'Ups ocurrió un error',
      description: 'No cuentas con los permisos para realizar esta acción',
    },
  }),

  methods: {
    close() {
      this.obj.reason = ''
      this.$emit('input', !this.value)
    },
    async imput() {
      this.toast.loading = true
      this.obj.id = this.student.id

      //Alumnos
      if (this.std === true) {
        if (this.isMassiveQrStudents) {
          const params = {
            ...this.obj,
            ids: this.student.map((e) => e.id),
          }

          try {
            await this.$store.dispatch('student/toggleMultipleQRStatus', params)
            this.toast.loading = false
            this.toast.success = true
            this.$emit(
              'updated',
              this.student.map((e) => ({ ...e, qrEnabled: true }))
            )
            this.close()
          } catch (error) {
            this.toast.loading = false
            this.toast.failed = true
          }
          return
        }

        this.$store
          .dispatch('student/blockQR', this.obj)
          .then(() => {
            this.toast.loading = false
            this.toast.success = true
            this.student.qrEnabled = true
            this.$emit('updated', this.student)
            this.close()
          })
          .catch((error) => {
            this.toast.loading = false

            if (error.data && error.data.code === 1017) {
              this.toast.unauthorized = true
              this.close()
            } else this.toast.failed = true
          })
      }
      //Colaborador
      if (this.coll === true) {
        this.$store
          .dispatch('employee/blockQR', this.obj)
          .then(() => {
            this.toast.loading = false
            this.toast.success = true
            this.student.qrEnabled = true
            this.$emit('updated', this.student)
            this.close()
          })
          .catch((error) => {
            this.toast.loading = false

            if (error.data && error.data.code === 1017) {
              this.toast.unauthorized = true
              this.close()
            } else this.toast.failed = true
          })
      }
      //Tutor
      if (this.par === true) {
        this.$store
          .dispatch('tutor/blockQR', this.obj)
          .then(() => {
            this.toast.loading = false
            this.toast.success = true
            this.student.qrEnabled = true
            this.$emit('updated', this.student)
            this.close()
          })
          .catch((error) => {
            this.toast.loading = false

            if (error.data && error.data.code === 1017) {
              this.toast.unauthorized = true
              this.close()
            } else this.toast.failed = true
          })
      }
    },
  },
  watch: {
    student() {
      if (Array.isArray(this.student)) {
        if (this.student.length === 1) {
          this.student = this.student[0]
        }
        this.isMassiveQrStudents = true
        return
      }

      this.isMassiveQrStudents = false
    },
  },
}
</script>

<style></style>
